import imageAsset from './imageAsset'
import productCategory from './productCategory'
import lifestyleCategory from './lifestyleCategory'
import material from './material'
import file from './file'
import { groq } from 'next-sanity'

export const basicFields = groq`
  "image": images[0].image {${imageAsset.fields}},
  "imageOrientation": images[0].imageOrientation,
  productCategory->{${productCategory.fields}},
  lifestyleCategory->{${lifestyleCategory.fields}}
`

export const fields = groq`
  description,
  style,
  materialOptions[]->{${material.fields}},
  variants[]{
    title,
    dimensions,
    comcol
  },
  images[]{
    ${imageAsset.fragment('image')},
    imageOrientation,
    "label": '',
    label == 'variantBased' => {
      "label": coalesce(variant, ''),
    },
    label == 'materialBased' => {
      "label": coalesce(material->title, ''),
    },
    label == 'customLabel' => {
      "label": coalesce(customLabel, ''),
    }
  },
  ${imageAsset.fragment('zoomImage')},
  galleryImages[]{
    ${imageAsset.fragment('image')},
    material->{${material.fields}}
  },
  productCategory->{${productCategory.fields}},
  lifestyleCategory->{${lifestyleCategory.fields}},
  ${file.fragment('specSheet')}
`

export const fragment = (name = 'productData') => `${name}{${fields}}`

const exported = {
  basicFields,
  fields,
  fragment,
}

export default exported
